import React, { useState, useEffect } from "react";
import MyCount from "../../../components/MyPage/MyCount";
import ProductSection from '../../../components/Product/ProductSection';
import PaginationSection from "../../../components/Product/Pagination";
import instance from "../../../services/services";
import { MY_PAGE_INTEREST_GOODS_URL } from "../../../utils/urls";
import { useLanguage } from "../../../hooks/useLanguage";



function WishList(){
  const { t } = useLanguage();
  const [isTablet, setIsTablet] = useState(false);
  const [activeTab, setActiveTab] = useState('rental');
  const [wishData, setWishData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    const fetchDetailData = async () => {
      try {
        const response = await instance.post(MY_PAGE_INTEREST_GOODS_URL,{
          goods_type: activeTab,
        });
        setWishData(response.data.data)

        setTotalCount(response.data.count);
      } catch (error) {
        console.error('실패', error);
      }
    };
    
    fetchDetailData();
  }, [activeTab]);


    // 모바일 체크
    useEffect(() => {
      const checkTablet = () => {
        setIsTablet(window.innerWidth < 768);
      };
      
      checkTablet();
      window.addEventListener('resize', checkTablet);
      
      return () => window.removeEventListener('resize', checkTablet);
    }, []);


    const handleActiveTab = (tab) =>{
      setActiveTab(tab);
    }

    const handlePageChange = (page) => {
      setCurrentPage(page);
      window.scrollTo(0, 0);
    };
  
    const handleArrowClick = (page) => {
      handlePageChange(page);
    };
  
  
    const AfterContent = () => (
      <div className="pagination_wrap">
          <PaginationSection
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onArrow={handleArrowClick}
          />
          
      </div>
    );

  
  return(
    <div>
      <div>
        {/* 장바구니 / 관심상품 / 쿠폰 */}
        {!isTablet && <MyCount/>}

        <div className="my_container point_container mt_48">
            <div className="order_title">
              <div className="d-flex">  
                <h3>{t("interest_product")}</h3>
                <span className="p2">({totalCount})</span>
              </div>
            </div>

            {/* 탭 */}
            <div className="wish_tabs mt_24">
              <div 
                className={`w_tab ${activeTab ==='rental' ?  'active' : ''}`}
                onClick={()=> handleActiveTab('rental')}
              >
                {t("rental_product4")}
              </div>
              <div 
                className={`w_tab ${activeTab ==='sale' ?  'active' : ''}`}
                onClick={()=> handleActiveTab('sale')}
              >
                SHOP
              </div>
            </div>


            <div className="wish_content_wrapper p0">
              {activeTab === 'rental' ? (
                <div>
                  {wishData.length === 0 ? (
                    <div className="default_info_table no_data text_center pt_48">
                      {t("interest_product2")}
                    </div>
                  ) : (
                    <div className="mt_24">
                      <ProductSection
                        products={wishData}
                        showTabs={false}
                        showMoreButton={false}
                        afterContent={<AfterContent />}
                        useSwiper={false}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {wishData.length === 0 ? (
                    <div className="default_info_table no_data text_center pt_48">
                      {t("interest_product2")}
                    </div>
                  ) : (
                    <div className="mt_24">
                      <ProductSection
                        products={wishData}
                        showTabs={false}
                        showMoreButton={false}
                        afterContent={<AfterContent />}
                        useSwiper={false}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
      </div>
    </div>
  )
};


export default WishList;